import React from 'react'
import Button from './Button'
import { Header2 } from '../styles/Components'
import { gsColors } from '../styles/Variables'
import styled from '@emotion/styled'
import { mq } from '../helpers'

export const BookEventWrapper = styled.section`
  width: 100%;
  padding: 80px 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 1600px;
  gap: 18px;

  ${mq('max', '768px')} {
    padding: 40px 0 20px;
  }

  button {
    margin-top: 50px;

    ${mq('max', '768px')} {
      margin-top: 25px;
      font-size: 16px;
    }
  }
`

const BookEvent = ({ handleClick, title, buttonTitle = 'Get Started' }) => {
  return (
    <BookEventWrapper>
      <Header2 align="center">{title}</Header2>
      <Button large color={gsColors.sunsetOrange} onClick={handleClick}>
        {buttonTitle}
      </Button>
    </BookEventWrapper>
  )
}

export default BookEvent
